export default "../images/stackloans-partners-with-penfed-credit-union.png?863e5c49ab051efc131f2085cef9e73a";